import React  from "react";
import { connect } from "react-redux";
import EmployeeDirectory from "./components/EmployeeDirectory";


const EmployeeDetails = () => {
  return (
    <div className="space-y-6">
      <div className="grid h-full grid-cols-1 gap-4">
        <EmployeeDirectory/>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDetails);